import { PHONE, locationSchema } from "../structured-data-core";

export function getNewarkStructuredData() {
  const url = "https://restorehair.com/locations/new-jersey/newark/";
  const description =
    "Find out about your hair transplant options in Newark with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Newark", "One Gateway Center", "Newark", "NJ", PHONE, url, description),
  ];
}
